import { render, staticRenderFns } from "./PayConfirm.vue?vue&type=template&id=3ad38dc2&scoped=true&"
import script from "./PayConfirm.vue?vue&type=script&lang=ts&"
export * from "./PayConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PayConfirm.vue?vue&type=style&index=0&id=3ad38dc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad38dc2",
  null
  
)

export default component.exports